module.exports = __webpack_public_path__ + "img/map-line.d832929d.png";